import { MobileProps } from "src/hooks/useIsMobile";
import { colors } from "src/styles";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 40px;
`;
export const Content = styled.div`
  padding: 15px 30px;
`;
export const TabsWrapper = styled(Content)`
  padding: 0;
`;
export const StatusTabsBar = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 32px;
  border-bottom: 1px solid ${colors.grey.light1};
  margin-bottom: 0;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 900px) {
    gap: 20px;
  }
`;

export const StatusTabButton = styled.button<{ $active: boolean }>`
  padding: 0 0 12px;
  margin-bottom: -1px;
  border: 0;
  border-bottom: 2px solid ${({ $active }) => ($active ? colors.black.dark1 : "transparent")};
  background: transparent;
  color: ${({ $active }) => ($active ? colors.black.dark1 : colors.grey.dark)};
  font-size: 11px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  white-space: nowrap;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    color: ${colors.black.dark1};
  }
`;

export const TabPanel = styled.div`
  padding-top: 16px;
`;
export const CreateButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  margin-right: 60px;
`;
export const Subtitle = styled.h3<MobileProps>`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.grey.dark6};
  margin-right: 10px;

  ${({ $isMobile }: MobileProps) =>
    $isMobile &&
    css`
      font-size: 12px;
    `}
`;

export const ServiceTypesRow = styled.div<MobileProps>`
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;

  a {
    margin-bottom: 30px;
    margin-right: 20px;

    ${({ $isMobile }: MobileProps) =>
      $isMobile &&
      css`
        width: 76px;
        height: 76px;
        border-radius: 10px;
        font-size: 10px;
        margin-bottom: 10px;
        margin-right: 5px;

        p {
          text-overflow: clip;
          font-size: 11px;
        }

        svg {
          width: 24px;
          height: 24px;
        }
      `}
  }
`;
